function a(i, t, $) {
  const e = {}, s = {}, l = /* @__PURE__ */ new Set();
  if (t.components)
    for (const n of t.components)
      l.add(n);
  for (const n of Object.keys(i))
    $.getComponent(n) && l.add(n);
  for (const [n, u] of Object.entries(i)) {
    const c = o(u);
    let f = !1;
    for (const r of l) {
      const g = $.getComponent(r);
      if (!g) continue;
      const h = $.config.getShorthands(r);
      if (h[n]) {
        const d = h[n];
        typeof d == "string" && x(
          r,
          d,
          c,
          g,
          s
        ) && (f = !0);
      } else x(
        r,
        n,
        c,
        g,
        s
      ) && (f = !0);
    }
    f || (e[n] = u);
  }
  for (const [n, u] of Object.entries(s)) {
    const c = Object.entries(u).map(([f, r]) => `${f}: ${r}`).join("; ");
    if (n in e) {
      const f = e[n];
      typeof f == "string" && f.trim() ? e[n] = `${c}; ${f}` : e[n] = c;
    } else
      e[n] = c;
  }
  return e;
}
function o(i) {
  if (typeof i == "string")
    return i;
  if (typeof i == "object" && i !== null && "x" in i) {
    const t = i;
    return "w" in t ? `${t.x} ${t.y} ${t.z} ${t.w}` : "z" in t ? `${t.x} ${t.y} ${t.z}` : `${t.x} ${t.y}`;
  } else
    return String(i);
}
function x(i, t, $, e, s) {
  const l = t.replace(
    /-([a-z])/g,
    (r, g) => g.toUpperCase()
  ), n = `${l}X` in e, u = `${l}Y` in e, c = `${l}Z` in e, f = `${l}W` in e;
  if (n && u && c) {
    s[i] || (s[i] = {});
    const r = $.trim().split(/\s+/);
    if (f && r.length === 4)
      return s[i][`${t}-x`] = r[0], s[i][`${t}-y`] = r[1], s[i][`${t}-z`] = r[2], s[i][`${t}-w`] = r[3], !0;
    if (r.length === 3 || r.length === 1) {
      const g = S($);
      return s[i][`${t}-x`] = String(g[0]), s[i][`${t}-y`] = String(g[1]), s[i][`${t}-z`] = String(g[2]), !0;
    }
  } else if (l in e)
    return s[i] || (s[i] = {}), s[i][t] = $, !0;
  return !1;
}
function S(i) {
  const t = i.trim().split(/\s+/).map(($) => parseFloat($) || 0);
  if (t.length === 1)
    return [t[0], t[0], t[0]];
  if (t.length === 3)
    return t;
  throw new Error(
    `Invalid vector3 value: "${i}". Expected 1 or 3 numbers.`
  );
}
export {
  a as expandShorthands,
  S as parseVector3
};
//# sourceMappingURL=shorthand-expander.js.map
